module.exports = __webpack_public_path__ + "static/media/tank-mask-1.9990cfc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tank-mask-1.png
// module id = 1141
// module chunks = 0